import {
  SseEventBus,
  type SseEventBusOptions,
} from '@webapp/core/libs/SseEventBus'
import type {
  EventBusDomainEventMap,
  IEventBus,
} from '@webapp/infrastructure/interfaces/services/IEventBus'

export type SseEventBusConfig = SseEventBusOptions

export function createSseEventBus<
  T extends EventBusDomainEventMap = EventBusDomainEventMap,
>(config: SseEventBusConfig): IEventBus<T> {
  return new SseEventBus<T>(config)
}
